import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {User} from '../_models/user.model';
import {RendererService} from '../_services/renderer.service';
import {KeycloakService} from 'keycloak-angular';

@Injectable({ providedIn: 'root' })
export class CapaAdminAuthGuard implements CanActivate {

    constructor(private router: Router,
                private oAuthService: OAuthService,
                private renderService: RendererService,
                private keycloakService: KeycloakService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Si on a un utilisateur azure
        if (localStorage.getItem('currentUser') != null) {
            const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
            // Si il est admin capa clhub
            if (this.keycloakService.isUserInRole('clhub-admin-capa')) {
                // Il est autorisé
                localStorage.removeItem('capaAccount');
                localStorage.setItem('isCapaAdmin', 'true');
                this.renderService.config.menu = true;
                return true;
            // L'utilisateur azure n'est pas admin
            } else {
                // On le redirige vers la page de connexion (qui le redirigera plus tard si besoin)
                this.router.navigate(['capa']);
                return false;
            }
        // Pas d'utilisateur azure, on vérifie si c'est un utilisateur capa
        } else if (localStorage.getItem('capaAccount') != null) {
            // on redirige au bon endroit
            this.router.navigate(['capa/result/list', 'account']);
            return false;
        // Aucun utilisateur connecté (capa/azure)
        } else {
            // On redirige vers la page de connexion
            this.router.navigate(['capa']);
            return false;
        }
    }
}
